import { DynamicContentType } from '../../types/content.types.js'
import { LucideIconName } from '../../types/lucide.types.js'
import { TextColor } from '../../types/text.types.js'
import { FontWeight } from '../../types/text.types.js'
import { TextAlignment } from '../../types/text.types.js'

export type RichTextData = {
  html: string
  marginBottom?: string
  marginTop?: string
  maxWidth?: string
  color?: TextColor
  fontWeight?: FontWeight
  alignment?: TextAlignment
}

export const richtext: DynamicContentType<RichTextData> = {
  name: 'richtext',
  viewName: 'Textbox',
  featureKey: 'richtext',
  icon: LucideIconName.TextAlignStart,
  default: true,
  uuid: '',
  data: {
    html: '<p>Mitt textinnehåll</p>',
    marginBottom: '1rem',
  },
}
